import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import ComposedSelectField from '../ComposedField/ComposedSelectField';
import { RL_REDACTED_CLASSNAME } from '../../utils/constants';
const options = (() => {
  const years = [];
  const start = new Date().getFullYear();

  //Generate 10 years into the future.
  for (let i = 0; i <= 10; i++) {
    const year = start + i;
    years.push({
      value: year.toString(),
      label: year.toString()
    });
  }
  return years;
})();
export default function CreditCardExpYear(_ref) {
  let {
    name = 'creditCardExpYear',
    label = 'Exp Year',
    autoComplete = 'cc-exp-year',
    visited: visitedProp = false,
    ...props
  } = _ref;
  const [visited, setVisited] = useState(visitedProp);
  const commonProps = {
    ...props,
    name,
    label,
    autoComplete,
    //until react-select is corrected this will show up as "off"
    visited,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onBlur: e => {
      setVisited(true);
      props.onBlur && props.onBlur(e);
    }
  };
  return /*#__PURE__*/React.createElement(ComposedSelectField, _extends({}, commonProps, {
    className: `${props === null || props === void 0 ? void 0 : props.className} ${RL_REDACTED_CLASSNAME}`.trim(),
    options: options
  }));
}